import { useConversation } from "@11labs/react";
import React, { useCallback } from "react";
import { appConfig } from "../config";
import AiBubble from "./AiBubble";

async function requestMicrophonePermission() {
  try {
    await navigator.mediaDevices.getUserMedia({ audio: true });
    return true;
  } catch {
    console.error("Microphone permission denied");
    return false;
  }
}

async function getSignedUrl() {
  const response = await fetch(`${appConfig.locale.ai}/api/signed-url`);
  if (!response.ok) {
    throw Error("Failed to get signed url");
  }
  const data = await response.json();
  return data.signedUrl;
}

export const AI = (props) => {
  const conversation = useConversation({
    clientTools: props.clientTools,
    dynamicVariables: props.dynamicVariables,
    onConnect: () => {
      console.log("connected");
    },
    onDisconnect: () => {
      console.log("disconnected");
    },
    onError: (error) => {
      console.log(error);
      alert("An error occurred during the conversation");
    },
    onMessage: (message) => {
      console.log(message);
    },
  });

  async function startConversation() {
    const hasPermission = await requestMicrophonePermission();
    if (!hasPermission) {
      alert("No permission");
      return;
    }
    const signedUrl = await getSignedUrl();
    const conversationId = await conversation.startSession({
      signedUrl,
      overrides: props.model
        ? {
            agent: {
              firstMessage: `Merhaba ben Isabella, hadi Saxdor ${props.model} için konfigurasyona başlayalım!`,
            },
          }
        : undefined,
    });

    props.onConnected(conversation);

    console.log(conversationId);
  }

  const stopConversation = useCallback(async () => {
    await conversation.endSession();
    props.onDisconnected();
  }, [conversation]);

  return (
    <div className="ai">
      {conversation.status === "connected" ? (
        <a onClick={stopConversation}>
          <AiBubble
            animating={
              conversation.status == "connected" && conversation.isSpeaking
            }
            connected={conversation.status == "connected"}
          />
        </a>
      ) : (
        <a onClick={startConversation}>
          <AiBubble animating={false} />
        </a>
      )}
    </div>
  );
};
